// modules
import * as R from 'ramda'
// setup
import { getState } from '$setup/redux'
// actions
import { DROP_ZONE_SET_IS_OPEN } from './fileDropZone.action'

// states
const initialState = {
  isOpen: false,
}

// views
export const fileDropZoneIsOpenView = () =>
  R.path(['view', 'app', 'chat', 'body', 'fileDropZone', 'isOpen'], getState())

// reducers
const reducers = {
  [DROP_ZONE_SET_IS_OPEN]: (state, isOpen) => ({ ...state, isOpen }),
}

export default (state = initialState, { type, payload }) =>
  reducers[type] ? reducers[type](state, payload) : state
